<div style="overflow:hidden;">
  <div class="row" style="height: 100vh;">
    <div class="col-md-6 mobImg" style="background-image: url(assets/img/loginImage.webp); background-repeat: no-repeat; background-size: cover;">
  
    </div>
  
  <div class="container col-md-5 xMargin">
  
      
      <div class="mx-auto ">
        <div class=" my-5">
          <div class="card-body">
            <h3 class="card-title text-center">LOG IN</h3>
  
            <form [formGroup]="loginFormGroup" (ngSubmit)="login()">
  
              <div *ngIf="loginFormGroup.controls.email.errors" class="text-danger md-1" >
                Vul een geldig e-mailadres in
              </div>
              <label class="font-weight-bold" for="email">E-mail</label>
              <div class="form-group">
                <input id="email" type="email" formControlName="email" class="form-control" placeholder="E-mail" required
                       autocomplete="email">
              </div>
  
              <div *ngIf="loginFormGroup.controls.password.errors" class="text-danger md-1">
                Vul uw wachtwoord in
              </div>
              <label class="font-weight-bold" for="password">Wachtwoord</label>
              <div class="form-group">
                <input id="password" type="password" formControlName="password" class="form-control"
                       placeholder="Password" minlength="6" required autocomplete="current-password">
              </div>
  
              <!-- Calling SignIn Api from AuthService -->
              <div class="form-group">
                <input type="submit" class="btn btn-lg btn-primary btn-block text-uppercase" value="Inloggen"
                  >
              </div>
  
            </form>
  
            <button class="btn btn-secondary btn-block" expand="block" fill="clear" routerLink="/wachtwoord-reset">
              Ik ben mijn wachtwoord vergeten.
            </button>
  
          </div>
        </div>
      </div>
    </div>
  </div>
  
</div>
